<section class="dashboard_content_sec">
  <div class="dashboard_bred_crumb">
    <ul>
      <li><img src="../../../../../assets/images/icons/bred_crumb_arrow.svg" alt=""></li>
      <li [routerLink]='["../../list"]'>My Pre-Owned Supplies</li>
      <li><img src="../../../../../assets/images/icons/bred_crumb_arrow.svg" alt=""></li>
      <li>Bids</li>
    </ul>
  </div>
  <div class="my_supplies_listing">
    <div class="" fxLayout="column" fxLayoutAlign="end end">
      <button type="button" class="btn btn-sm global-btn" mat-button (click)="closeBidDialog()"> Close Bid </button>
    </div>
    <!-- TABLE-LISTING -->
    <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row" fxLayout.xs="column"
      fxLayoutAlign="start stretch" fxLayoutGap="15px">
      <div fxLayout="column" fxFlex="100" fxFlexFill>
        <!-- tables-section -->
        <section class="table_section">
          <div class="custom-sticky-table" fxLayout="column" fxLayoutAlign="start stretch">
            <perfect-scrollbar>
              <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
                <!-- Position Column -->
                <ng-container matColumnDef="sNo">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>S.No</th>
                  <td mat-cell *matCellDef="let element;let i = dataIndex" data-label="S.No"> {{ i+1 }} </td>
                </ng-container>
                <!-- Name Column -->
                <ng-container matColumnDef="username">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>User Name</th>
                  <td mat-cell *matCellDef="let element" data-label="User Name">
                    {{element?.dental_supplier?.name}}
                    {{element?.dental_practice?.name}}
                    {{element?.dental_professional?.name}}
                  </td>
                </ng-container>
                <!-- Bid Price Column -->
                <ng-container matColumnDef="price">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Bid Price</th>
                  <td mat-cell *matCellDef="let element" data-label="Bid Price">
                    {{element.price}}
                  </td>
                </ng-container>
                <!-- Bid Price Column -->
                <ng-container matColumnDef="created_at">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Bid Date Time </th>
                  <td mat-cell *matCellDef="let element" data-label="Bid Date Time">
                    {{element.created_at | date: "dd-mm-yyyy hh:mm a"}}
                  </td>
                </ng-container>
                <!-- Message -->
                <ng-container matColumnDef="message">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Message </th>
                  <td mat-cell *matCellDef="let element" data-label="Message" class="bid_message_td">
                    {{element.message}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="loading">
                  <th mat-footer-cell *matFooterCellDef colspan="8">
                    <div class="custom-loader ">
                          <div class="custom-loader custom_logo_loader">
                        <img src='../../../../../assets/images2/loader.gif' alt="img" loading="lazy" />
                      </div>
                    </div>
                  </th>
                </ng-container>
                <ng-container matColumnDef="noData">
                  <th mat-footer-cell *matFooterCellDef colspan="8" class="no-data empty-img">
                    <img src='../../../../../../../assets/images/empty-imgs/no_bids.svg' alt="img" loading="lazy" />
                    <h4 class="no_state_heading">No Bid's</h4>
                  </th>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{ hide: dataSource != null }"></tr>
                <tr mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{hide: !( dataSource != null && dataSource.filteredData.length == 0)
            }"></tr>
              </table>
            </perfect-scrollbar>
          </div>
        </section>
        <!-- TABLE-PAGINATOR -->
        <div fxLayout="column" fxLayout.lg="column" fxLayout.md="column" fxLayout.sm="column" fxLayout.xs="column"
          fxFlexFill fxLayoutGap="8px">
          <mat-paginator [length]="totalElements" [pageSize]="limit.value" (page)="changePage($event)"></mat-paginator>
        </div>
      </div>
    </div>
  </div>
</section>
